export default class Jackpots {
    constructor(api) {
        this.api = api;
        this.JackpotsClass = null;
    }

    async init(instance) {
        if (this.api && this.api.settings && this.api.settings.jackpotsInstance && this.api.settings.jackpotsInstance !== instance.instance) {
            return;
        }
        if (!this.JackpotsClass) {
            if (instance.data && instance.data.cdn && instance.data.cdn.js) {
                await this.api.util.loadJS(instance.data.cdn.js);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.jackpots &&
                this.api.settings.widgetsUrl.jackpots.js
            ) {
                await this.api.util.loadJS([this.api.settings.widgetsUrl.jackpots.js]);
            }

            if (instance.data && instance.data.cdn && instance.data.cdn.css) {
                await this.api.util.loadCSS(instance.data.cdn.css);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.jackpots &&
                this.api.settings.widgetsUrl.jackpots.css
            ) {
                await this.api.util.loadCSS([this.api.settings.widgetsUrl.jackpots.css]);
            }

            // this.JackpotsClass = new window.Widget_jackpots.default(this.api, instance.instance, instance.data.settings);
        }

        if (window.store) {
            window.store.dispatch('addInstanceToContainer', instance.instance)
            this.createInstance(instance)
        }
    }
    createInstance(instance) {
        if (!document.getElementById(`ox-drawer-instance-container-${instance.instance}-inner`)) {
            setTimeout(()=> {
                this.createInstance(instance)
            },100)
        } else {
            this.jackpotsClass = new window.Widget_jackpots.default(this.api, instance.instance, instance.data.settings, `#ox-drawer-instance-container-${instance.instance}-inner`);
        }
    }
}



